var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marginEnquiry"},[_c('FORM',{ref:"childForm",attrs:{"formData":_vm.formData},on:{"formclick":_vm.formclick}}),_vm._v(" "),_c('UPDATE',{ref:"childUpdate",attrs:{"updateData":_vm.updateData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }